import { notEmpty, type Optional } from '@festina-life/core'
import { useMemo } from 'react'

import { useHook } from '../lenteHooks'

type Props = {
  tenantId: string
  ownerId: string
}

export const useScenarios = ({ tenantId, ownerId }: Props) => {
  const { data: scenarios } = useHook('fetchers.life.useFetchScenarios')({
    tenantId,
    ownerId,
  })

  return useMemo(
    () =>
      scenarios?.scenarioVersions
        ?.filter(notEmpty)
        ?.filter(
          (scenario) =>
            !scenario.scenarioAppliedVersion &&
            !scenario.scenarioCancellationVersion,
        ) ?? [],
    [scenarios?.scenarioVersions],
  )
}

type ScenarioAndVariantProps = Props & {
  scenarioId: Optional<string>
  variantId: Optional<string>
}

export const useScenarioAndVariant = ({
  tenantId,
  ownerId,
  scenarioId,
  variantId,
}: ScenarioAndVariantProps) => {
  const scenarios = useScenarios({ tenantId, ownerId })

  return useMemo(() => {
    const scenario = scenarios.find((s) => s._id === scenarioId)
    const variant = scenario?.scenarioVariantVersions?.find(
      (v) => v?._id === variantId,
    )

    return { scenario, variant }
  }, [scenarioId, scenarios, variantId])
}
